import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import { addBreadcrumb } from "/redux/action-creaters/breadcrumbs";
import { wrapper } from "/redux";
import Redis from "/lib/redis";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function PrivacyPage({ scripts, host }) {
  const { content } = useSelector((state) => state.meta);
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <div className="container text">
        <div className={styles.Text}>
          <div
            dangerouslySetInnerHTML={{
              __html: content?.replaceAll("#SITE#", host),
            }}
          />
        </div>
      </div>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    store.dispatch(
      addBreadcrumb({
        link: "/privacy/",
        name: "Политика конфиденциальности",
      }),
    );

    return pagesWrapper(
      { pageType: SITE_PAGE_TYPE.static },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/privacy/",
    );
  }),
);
